import { Button, Image } from 'antd';
import type { FC } from 'react';
import React, { useState } from 'react';

import styles from './styles.module.scss';

const ShowImage: FC<{ image: string }> = ({ image }) => {
  const [showImage, setShowImage] = useState(false);

  return (
    <>
      <Button
        type="text"
        onClick={() => setShowImage(true)}
        className={styles.button}
      >
        📎 影像
      </Button>
      {showImage && (
        <Image
          hidden
          preview={{
            visible: showImage,
            onVisibleChange: (visible) => setShowImage(visible),
            src: image,
          }}
          src={image}
          onClick={() => setShowImage(false)}
        />
      )}
    </>
  );
};

export default ShowImage;
